import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useInquiry } from "@/components/InquiryModal";

const FinalCta = () => {
  const { open } = useInquiry();
  return (
    <section data-testid="final-cta-section" className="bg-cream py-20 md:py-28 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2rem] bg-charcoal px-8 py-16 md:px-16 md:py-24 text-center shadow-[0_40px_80px_-24px_rgba(32,32,32,0.45)]">
            <div className="noise-overlay" aria-hidden="true" />
            <div
              className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-turquoise/20 blur-[110px] pointer-events-none"
              aria-hidden="true"
            />
            <div
              className="absolute -bottom-32 -left-24 w-96 h-96 rounded-full bg-champagne/15 blur-[110px] pointer-events-none"
              aria-hidden="true"
            />
            <div className="relative">
              <p className="text-xs font-sans uppercase tracking-[0.28em] font-semibold text-champagne mb-6">
                Ready When You Are
              </p>
              <h2
                data-testid="final-cta-headline"
                className="font-serif font-medium tracking-tight text-cream text-3xl sm:text-4xl lg:text-5xl leading-[1.12] max-w-3xl mx-auto"
              >
                Your Business Deserves a Website That{" "}
                <span className="italic text-turquoise">Works.</span>
              </h2>
              <p className="mt-6 font-sans text-base sm:text-lg text-cream/70 max-w-xl mx-auto leading-relaxed">
                Let's create a professional online presence you'll be proud to share.
              </p>
              <button
                data-testid="final-cta-button"
                onClick={open}
                className="group mt-10 inline-flex items-center gap-2 bg-turquoise text-charcoal hover:bg-turquoise-dark px-10 py-4 rounded-full font-sans font-semibold text-base shadow-[0_20px_40px_-12px_rgba(0,175,163,0.5)] transition-[background-color,transform,box-shadow] duration-300 hover:-translate-y-0.5"
              >
                Let's Get Started
                <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCta;
